export default "__VITE_ASSET__BQxO9sM2__"